<div
  (mouseenter)="collapseOpenSidenav()"
  (mouseleave)="collapseCloseSidenav()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen$ | async"
  class="flex flex-col sidenav"
  >
  <div class="flex flex-col vex-sidenav-toolbar__container">
    <div class="flex flex-col items-center justify-center sidenav-toolbar">
      <a [routerLink]="['/']">
        <img
          [src]="imageDarkUrl$ | async"
          alt="Kodl logo"
          class="w-24 text-center"
          width="890"
          height="520"
          />
      </a>
    </div>

    @if (searchVisible$ | async) {
      <div class="vex-sidenav-search__container">
        <div
          class="relative vex-sidenav-search"
          (click)="openSearch()"
          matRipple
          matRippleColor="var(--sidenav-item-ripple-color)"
          >
          <mat-icon
            class="flex-none vex-sidenav-search__icon"
            svgIcon="mat:search"
          ></mat-icon>
          <div class="flex-auto vex-sidenav-search__placeholder">
            Rychlé vyhledávání
          </div>
          <div class="flex-none vex-sidenav-search__keybind">CTRL+K</div>
        </div>
      </div>
    }

    <div class="vex-sidenav-toolbar__divider"></div>
  </div>

  <vex-scrollbar class="flex flex-col flex-1">
    <div class="flex-1 pt-6">
      @for (item of items; track item) {
        <vex-sidenav-item [item]="item" [level]="0"></vex-sidenav-item>
      }
    </div>
  </vex-scrollbar>

  @if(!collapsed){
    <div
      class="flex flex-col items-center justify-center flex-none px-6 py-6 space-y-1 select-none"
      >
      <solution-by-beckapp></solution-by-beckapp>
      <small class="text-center text-gray-400">v{{ version }}</small>
    </div>
  }

  @if (false) {
    <div class="flex-none vex-sidenav-user__container">
      <div
        #userProfileMenuOriginRef
        (click)="openProfileMenu(userProfileMenuOriginRef)"
        [class.vex-sidenav-user--open]="userMenuOpen$ | async"
        class="flex items-center vex-sidenav-user"
        matRipple
        matRippleColor="var(--sidenav-item-ripple-color)"
        >
        <img
          alt="User Avatar"
          class="flex-none vex-sidenav-user__image"
          src="assets/img/avatars/1.jpg"
          />
        <div class="flex-auto vex-sidenav-user__content">
          <div class="vex-sidenav-user__title">David Smith</div>
          <div class="vex-sidenav-user__subtitle">Product Manager</div>
        </div>
        <mat-icon
          class="flex-none vex-sidenav-user__dropdown-icon"
          svgIcon="mat:arrow_drop_down"
        ></mat-icon>
      </div>
    </div>
  }
</div>
